"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf3 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

require("../listeners/focusStylesListener");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireWildcard(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _devLogger = _interopRequireDefault(require("react-utils/devLogger"));

var _memoize = _interopRequireDefault(require("react-utils/memoize"));

var _CheckboxConstants = require("./CheckboxConstants");

var _UICheckmark = _interopRequireDefault(require("../icon/icons/UICheckmark"));

var _underscore = require("../utils/underscore");

var _BrowserTest = require("../utils/BrowserTest");

var _DomEvents = require("../utils/DomEvents");

var _TabIndex = require("../utils/TabIndex");

var _tshirtSize = require("../utils/propTypes/tshirtSize");

var _FieldsetContext = require("../context/FieldsetContext");

var _Checkable = _interopRequireDefault(require("../decorators/Checkable"));

// Prevent unwanted focus styles
var renderLabelText = function renderLabelText(ariaLabel, children, longhandSize) {
  if (children == null && !ariaLabel) {
    _devLogger.default.warn({
      message: "UICheckbox: `aria-label` is required if you don't define `children`.",
      key: 'UICheckbox: aria-label required'
    });
  }

  if (children && ariaLabel) {
    _devLogger.default.warn({
      message: 'UICheckbox: `aria-label` should not be used with `children`.',
      key: 'UICheckbox: aria-label & children'
    });
  }

  if (children == null) return null;
  return _react.default.createElement("span", {
    className: (0, _classnames.default)('private-checkbox__text', {
      'private-checkbox__text--small': longhandSize === 'small'
    })
  }, children);
};

var renderCheckmark = (0, _memoize.default)(function () {
  return _react.default.createElement(_UICheckmark.default, {
    className: "private-checkbox__icon__inner"
  });
});
var renderDash = (0, _memoize.default)(function () {
  return _react.default.createElement("svg", {
    role: "presentation",
    viewBox: "0 0 14 14",
    xmlns: "http://www.w3.org/2000/svg"
  }, _react.default.createElement("path", {
    className: "private-checkbox__icon__inner",
    d: "M 2 6 L12 6 L12 9 L2 9 L2 6 z"
  }));
});
var renderIndicator = (0, _memoize.default)(function (color) {
  return _react.default.createElement("span", {
    className: "private-checkbox__indicator",
    "data-indicator": true,
    style: {
      color: color
    }
  }, _react.default.createElement("span", {
    className: "private-checkbox__icon private-checkbox__check"
  }, renderCheckmark()), _react.default.createElement("span", {
    className: "private-checkbox__icon private-checkbox__dash"
  }, renderDash()));
});

var UICheckbox =
/*#__PURE__*/
function (_Component) {
  (0, _inherits2.default)(UICheckbox, _Component);

  function UICheckbox() {
    var _getPrototypeOf2;

    var _this;

    (0, _classCallCheck2.default)(this, UICheckbox);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = (0, _possibleConstructorReturn2.default)(this, (_getPrototypeOf2 = (0, _getPrototypeOf3.default)(UICheckbox)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _this.handleChange = function (evt) {
      var _this$props = _this.props,
          disabled = _this$props.disabled,
          onChange = _this$props.onChange,
          readOnly = _this$props.readOnly;

      if (disabled || readOnly) {
        evt.preventDefault();
        return;
      }

      onChange(evt);
    };

    _this.handleLabelClick = function (evt) {
      var _this$props2 = _this.props,
          checked = _this$props2.checked,
          onChange = _this$props2.onChange;

      if ((0, _BrowserTest.isFirefox)() && (0, _DomEvents.isModifierPressed)(evt)) {
        onChange((0, _extends2.default)({}, evt, {
          type: 'change',
          target: {
            checked: !checked
          }
        }));
      }
    };

    return _this;
  }

  (0, _createClass2.default)(UICheckbox, [{
    key: "render",
    value: function render() {
      var _this$props3 = this.props,
          alignment = _this$props3.alignment,
          ariaLabel = _this$props3['aria-label'],
          ariaLabelledBy = _this$props3['aria-labelledby'],
          checked = _this$props3.checked,
          children = _this$props3.children,
          className = _this$props3.className,
          color = _this$props3.color,
          description = _this$props3.description,
          descriptionLayout = _this$props3.descriptionLayout,
          disabled = _this$props3.disabled,
          id = _this$props3.id,
          indeterminate = _this$props3.indeterminate,
          inline = _this$props3.inline,
          innerPadding = _this$props3.innerPadding,
          labelClassName = _this$props3.labelClassName,
          name = _this$props3.name,
          __onChange = _this$props3.onChange,
          readOnly = _this$props3.readOnly,
          size = _this$props3.size,
          tabIndex = _this$props3.tabIndex,
          value = _this$props3.value,
          rest = (0, _objectWithoutProperties2.default)(_this$props3, ["alignment", "aria-label", "aria-labelledby", "checked", "children", "className", "color", "description", "descriptionLayout", "disabled", "id", "indeterminate", "inline", "innerPadding", "labelClassName", "name", "onChange", "readOnly", "size", "tabIndex", "value"]);
      var _this$context = this.context,
          fieldSize = _this$context.size,
          fieldDisabled = _this$context.disabled;
      var computedDescId = description ? (0, _underscore.uniqueId)('checkbox-') : null;
      var longhandSize = (0, _tshirtSize.toLonghandSize)(size || fieldSize);
      var computedDisabled = disabled || fieldDisabled;
      var wrapperClassName = (0, _classnames.default)('private-checkbox', _CheckboxConstants.ALIGNMENT_CLASSES[alignment], _CheckboxConstants.PADDING_OPTIONS[innerPadding], _CheckboxConstants.SIZE_OPTIONS[longhandSize], {
        'private-checkbox--disabled': computedDisabled,
        'private-checkbox--readonly': readOnly,
        'private-checkbox--inline': inline,
        'private-checkbox--unlabeled': children == null,
        'private-checkbox--stack-contents': description && descriptionLayout === 'vertical'
      }, className);
      return _react.default.createElement("div", (0, _extends2.default)({}, rest, {
        className: wrapperClassName
      }), _react.default.createElement("label", {
        className: (0, _classnames.default)('private-checkbox__label', labelClassName),
        onClick: this.handleLabelClick
      }, _react.default.createElement("span", {
        className: "private-checkbox__inner"
      }, _react.default.createElement("input", {
        "aria-describedby": computedDescId,
        "aria-label": ariaLabel,
        "aria-labelledby": ariaLabelledBy,
        checked: checked,
        className: (0, _classnames.default)('private-checkbox__input sr-only', {
          indeterminate: indeterminate
        }),
        disabled: computedDisabled,
        id: id,
        name: name,
        onChange: this.handleChange,
        readOnly: readOnly,
        type: "checkbox",
        value: value,
        tabIndex: (0, _TabIndex.getTabIndex)(readOnly || disabled, tabIndex)
      }), renderIndicator(color), renderLabelText(ariaLabel, children, longhandSize))), description && _react.default.createElement("span", {
        className: "private-checkbox__desc",
        id: computedDescId
      }, description));
    }
  }]);
  return UICheckbox;
}(_react.Component);

UICheckbox.contextType = _FieldsetContext.FieldsetContext;
UICheckbox.propTypes = {
  alignment: _propTypes.default.oneOf(Object.keys(_CheckboxConstants.ALIGNMENT_CLASSES)),
  'aria-label': _propTypes.default.string,
  'aria-labelledby': _propTypes.default.string,
  checked: _propTypes.default.bool,
  children: _propTypes.default.node,
  color: _propTypes.default.string,
  description: _propTypes.default.node,
  descriptionLayout: _propTypes.default.oneOf(['horizontal', 'vertical']),
  disabled: _propTypes.default.bool,
  indeterminate: _propTypes.default.bool,
  inline: _propTypes.default.bool,
  innerPadding: _propTypes.default.oneOf(Object.keys(_CheckboxConstants.PADDING_OPTIONS)).isRequired,
  labelClassName: _propTypes.default.string,
  name: _propTypes.default.string,
  onChange: _propTypes.default.func,
  readOnly: _propTypes.default.bool,
  size: _propTypes.default.oneOfType([(0, _tshirtSize.propTypeForSizes)(['sm']), _propTypes.default.oneOf(['default'])]),
  value: _propTypes.default.any
};
UICheckbox.defaultProps = {
  alignment: 'start',
  checked: false,
  descriptionLayout: 'vertical',
  innerPadding: 'default'
};
UICheckbox.displayName = 'UICheckbox';

var _default = (0, _Checkable.default)(UICheckbox);

exports.default = _default;
module.exports = exports.default;